// extracted by mini-css-extract-plugin
export default {"productDescription":"Sba-z","featuredDescription":"Tba-z","description":"Uba-z","more":"Vba-z","descriptionSku":"Wba-z"};